if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function contact() {
  $(".productContact").fadeIn().css("display", "flex");
}

function contactSubmit() {
  var id = document.getElementById("ct_id").value;
  var emailValue = document.getElementById("ct_email").value;
  var nameValue = document.getElementById("ct_name").value;
  var contentValue = document.getElementById("ct_text").value;

  var emailValidationMsg = document.getElementById("emailValidationMsg2");
  var nameMsg = document.getElementById("nameMsg");
  var contentMsg = document.getElementById("contentMsg");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // 이름 값이 비어 있는지 확인
  if (nameValue === "") {
    nameMsg.textContent = "Please type your name";
  } else {
    nameMsg.textContent = ""; // 에러 메시지를 지웁니다.
  }

  // 내용 값이 비어 있는지 및 최소 길이를 확인
  if (contentValue === "") {
    contentMsg.textContent = "Please enter the content";
  } else if (contentValue.length < 5) {
    // 최소 길이 조건 추가 (예시)
    contentMsg.textContent = "Content should be at least 5 characters long";
  } else {
    contentMsg.textContent = ""; // 에러 메시지를 지웁니다.
  }

  // 이메일 값이 비어 있는지 및 형식이 올바른지 확인
  if (emailValue === "") {
    emailValidationMsg.textContent =
      "The required value is missing, please type your email.";
  } else if (!emailRegex.test(emailValue)) {
    emailValidationMsg.textContent = "Invalid email format";
  } else {
    // 모든 조건이 충족되었을 때만 handleSubmit2 실행
    if (nameValue !== "" && contentValue !== "" && contentValue.length >= 5) {
      try {
        handleSubmit2(id, emailValue, nameValue, contentValue);
      } catch (error) {
        emailValidationMsg.textContent =
          "An error occurred. Please try again later.";
      }
    }
  }
}

const handleSubmit2 = async (id, email, name, content) => {
  try {
    const loadingDiv = document.querySelector(".loading");
    loadingDiv.classList.add("active");

    const formData = new URLSearchParams();
    formData.append("id", id);
    formData.append("email", email);
    formData.append("name", name);
    formData.append("content", content);

    const response = await fetch("https://verify.ofotd.com/shopify/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    });

    loadingDiv.classList.remove("active");
    if (response.ok) {
      document.getElementById("contactForm").innerHTML =
        "<div class='resultMsg'><p class='success'>Request Submitted</p><p class='success'>Your request has been received. A reply will follow shortly.</p></div>";
    }
  } catch (error) {
    // Handle error appropriately
    emailValidationMsg.textContent =
      "An error occurred. Please try again later.";
  }
};

document.addEventListener("DOMContentLoaded", function () {
  // .btnOnb 요소를 찾습니다.
  var btnOnb = document.querySelector(".btnOnb");
  var close = document.querySelector(".close");

  // .btnOnb 요소를 클릭할 때마다 toggleActive 함수를 호출합니다.
  btnOnb.addEventListener("click", toggleActive);
  close.addEventListener("click", toggleActive);

  function toggleActive() {
    // .obForm 요소를 찾습니다.
    var obForm = document.querySelector(".obWrap");

    // .obForm 요소에 active 클래스가 있는지 확인합니다.
    var isActive = obForm.classList.contains("active");

    // active 클래스를 추가하거나 제거합니다.
    if (isActive) {
      obForm.classList.remove("active");
    } else {
      obForm.classList.add("active");
    }
  }
});
